import * as React from "react";
import {Icon, IConcreteIcon} from "../Icon";

export const MasterCardIcon = ({style}: IConcreteIcon) => <Icon file="/icons/payment_methods/mastercard.svg" style={style} />;
